import {CompanyState, CompanyType} from "@/helpers/constants";
import IListFilter from "@/models/IListFilter";
import {isEmpty} from "@/helpers/functions_asi";

export default class CompanyListFilter implements IListFilter {

	private static readonly defaultStateFilter = [CompanyState.active];
	private readonly defaultStateFilterInternal: CompanyState[] = [];

	public includeIds: string[] = [];
	public fulltext: string | null = null;

	public states: CompanyState[] = [];
	public name: string | null = null;
	public types: CompanyType[] = [];
	public contactAddressSummary: string | null = null;
	public billingAddressSummary: string | null = null;
	public notes: string | null = null;

	public constructor(defaultStateFilter: CompanyState[] | null = null) {
		this.defaultStateFilterInternal = defaultStateFilter === null ? CompanyListFilter.defaultStateFilter : defaultStateFilter;
		this.states = this.defaultStateFilterInternal;
	}

	public clear(): void {
		this.fulltext = null;
		this.states = CompanyListFilter.defaultStateFilter;
		this.name = null;
		this.types = [];
		this.contactAddressSummary = null;
		this.billingAddressSummary = null;
		this.notes = null;
	}

	public hasFilter(): boolean {
		if (this.states.length !== this.defaultStateFilterInternal.length) {
			return true;
		}

		for (let i = 0; i < this.states.length; i++) {
			if (!this.defaultStateFilterInternal.includes(this.states[i])) {
				return true;
			}
		}

		return !isEmpty(this.fulltext)
			|| !isEmpty(this.name)
			|| this.types.length > 0
			|| !isEmpty(this.contactAddressSummary) || !isEmpty(this.billingAddressSummary)
			|| !isEmpty(this.notes);
	}

}
